import { setLoader } from "src/app-redux/gate-entry/gateEntrySlice";
import { IBinaryFileMetaData, IS3FileMetaData } from "../typings/s3-file-metadata";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";

export function downloadS3FileFromSignedURL(fileMetaData: IS3FileMetaData) {
  const headers = {
    "Content-Type": fileMetaData.contentType,
  };
  fetch(fileMetaData.url, { headers })
    .then((response) => {
      if (response.status === 200) return response.blob();
      else throw response;
    })
    .then((data) => {
      const newBlob = new Blob([data]);
      const link = document.createElement("a");
      const payloadUrl = window.URL.createObjectURL(new File([newBlob], fileMetaData.fileName));

      link.href = payloadUrl;
      link.download = `${fileMetaData.fileName}${getFileExtFromContentType(
        fileMetaData.contentType
      )}`;
      link.click();
    })
    .catch((error) => {
      throw error;
    });
}
export function printFileCommon(fileMetaData: IS3FileMetaData, dispatch: any) {
  dispatch(setLoader(true));
  const idToken = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${idToken}`,
    "Content-Type": fileMetaData.contentType,
  };
  fetch(fileMetaData.url, { headers })
    .then((response) => {
      if (response.status === 200) return response.blob();
      else if (response.status === 401)
        return dispatch(
          addNotificationAction({
            message: "You are unauthorized for this action",
            options: { variant: "error" },
          })
        );
      else throw response;
    })
    .then((data) => {
      const blob = new Blob([data], { type: "application/pdf" });
      const blobURL = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe"); //load content in an iframe to print later
      document.body.appendChild(iframe);

      iframe.style.display = "none";
      iframe.src = blobURL;
      iframe.onload = function () {
        setTimeout(function () {
          iframe.focus();
          iframe.contentWindow?.print();
        }, 1);
      };
      dispatch(setLoader(false));
    })
    .catch((error) => {
      dispatch(setLoader(false));
      throw error;
    });
}
export function downloadFileCommon(fileMetaData: IS3FileMetaData) {
  const idToken = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${idToken}`,
    "Content-Type": fileMetaData.contentType,
  };
  fetch(fileMetaData.url, { headers })
    .then((response) => {
      if (response.status === 200) return response.blob();
      else throw response;
    })
    .then((data) => {
      const newBlob = new Blob([data]);
      const link = document.createElement("a");
      const payloadUrl = window.URL.createObjectURL(new File([newBlob], fileMetaData.fileName));

      link.href = payloadUrl;
      link.download = `${fileMetaData.fileName}${getFileExtFromContentType(
        fileMetaData.contentType
      )}`;
      link.click();
    })
    .catch((error) => {
      throw error;
    });
}
export function downloadFileBinary(fileMetaData: IBinaryFileMetaData) {
  const link = document.createElement("a");
  const payloadUrl = window.URL.createObjectURL(
    new File([fileMetaData.blob], fileMetaData.fileName)
  );

  link.href = payloadUrl;
  link.download = `${fileMetaData.fileName}${getFileExtFromContentType(fileMetaData.contentType)}`;
  link.click();
}

export function viewS3FileDocument(data: any) {
  const payload = data;
  const file = new Blob([payload], { type: "application/pdf" });
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL, "_blank");
}
function getFileExtFromContentType(contentType: string) {
  let fileExtension = "";
  switch (contentType) {
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      fileExtension = ".xlsx";
      break;
    case "application/pdf":
      fileExtension = ".pdf";
      break;
    default:
  }
  return fileExtension;
}
